export default __webpack_public_path__ + "static/media/dependent.e53d5d1f.svg";